module.exports = __webpack_public_path__ + "img/2.965a52e6.jpg";